import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationVI from './locales/vi/translation.json';
import translationFR from './locales/fr/translation.json';
import translationZHCN from './locales/zh-Cn/translation.json';
import translationJA from './locales/ja/translation.json';
import translationKO from './locales/ko/translation.json';
import translationDE from './locales/de/translation.json';

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    vi: {
        translation: translationVI
    },
    fr: {
        translation: translationFR
    },
    'zh-CN': {
        translation: translationZHCN
    },
    ja: {
        translation: translationJA
    },
    ko: {
        translation: translationKO
    },
    de: {
        translation: translationDE
    }
};

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'vi',
        debug: false,
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        }
    });

export default i18n;
